import { createFileRoute } from "@tanstack/react-router";
import { CollectionRecordPage } from "@/components/collections/record-form/collection-record-page";

export const Route = createFileRoute("/_authenticated/collections/$collectionId/records/$recordId")({
  component: RecordPage,
});

/** Edición de un registro en página (la colección eligió «Página» en su formulario). */
function RecordPage() {
  const { collectionId, recordId } = Route.useParams();
  return <CollectionRecordPage collectionId={collectionId} recordId={recordId} />;
}
